enum ProtectedFeatures {
  BookMeeting,
  AskQuestion,
  MyOrganizationSections,
  MyOrganizationInfo,
  EmergencyButton,
}

export default ProtectedFeatures;
